"use client";

import { Box, MenuItem, Typography } from '@mui/material';
import '@/style/css/Profil.css';
import { MouseEvent, useContext, useState } from 'react';
import TokenContext from '@/context/TokenProvider';
import { useNotifikasi } from "@/utils/Hooks";
import NotificationCard from "@/components/Notifikasi/NotificationCard";
import { NotifikasiReceipt } from '@/types/shared.types';
import { useLocalStorage } from 'usehooks-ts';

interface NotifikasiScreenContentsProps {
  handleClose: () => void;
  data: NotifikasiReceipt[];
}

const NotifikasiScreenContents = (props: NotifikasiScreenContentsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [pushRequestShown, setPushRequestShown, removePushRequestShown] = useLocalStorage('push-request-shown', '');
  const [toRequestPushNotifications, setToRequestPushNotifications] = useState(!pushRequestShown);

  const { authenticatedFetcher } = useContext(TokenContext)!;
  const { data: notifikasiResponse } = useNotifikasi(authenticatedFetcher);


  const notifications = notifikasiResponse?.rows;
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLLIElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!notifications || notifications.length === 0) {
    return <Box sx={{ padding: '10px', textAlign: 'center' }}>
      <Typography variant="body2" color="textSecondary">
        Tidak ada notifikasi.
      </Typography>
    </Box>;
  }

  if (!("Notification" in window)) {
    setToRequestPushNotifications(false);
  } else if (Notification.permission === "granted") {
    setToRequestPushNotifications(false);
  } else if (Notification.permission !== "denied") {
  }

  const requestPushNotifications = async () => {
    setToRequestPushNotifications(false);
    setPushRequestShown('true');
    await Notification.requestPermission();
    if (Notification.permission === "granted") {
      // TODO subscribe
    }
  };

  return <>
    {toRequestPushNotifications && <MenuItem
      sx={{
        display: "block",
        whiteSpace: "normal",
        fontSize: "0.9rem",
        borderBottom: "1px solid #E0E0E0",
        ':first-child': {
          borderTop: "1px solid #E0E0E0"
        },
        paddingBottom: 1.5,
        paddingTop: 1.5,
        background: 'rgb(255, 244, 229)',
      }}
      onClick={requestPushNotifications}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          marginBottom: 1,
          fontSize: 'inherit'
        }}>Push Notification</Typography>
      <Typography
        sx={{
          fontSize: 'inherit'
        }}>Nyalakan push notification agar Anda dapat menerima informasi lebih cepat.</Typography>
    </MenuItem>
    }
    {notifications.map((notification, key) => (
      <NotificationCard
        notification={notification}
        key={key}
      />
    ))}
  </>

};

export default NotifikasiScreenContents;
